import { render, staticRenderFns } from "./discountApplied.vue?vue&type=template&id=7b89fef4&"
import script from "./discountApplied.vue?vue&type=script&lang=js&"
export * from "./discountApplied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports